(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const root = window.BALDY = window.BALDY || {};
  const money = (c) => {
    const v = (c / 100).toFixed(2);
    return (root.moneyFormat || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(c / 100)).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','));
  };

  const mnav = $('#MobileNav');
  $$('[data-menu-open]').forEach(b => b.addEventListener('click', () => { mnav.classList.add('is-open'); document.body.style.overflow = 'hidden'; }));
  $$('[data-menu-close]').forEach(b => b.addEventListener('click', () => { mnav.classList.remove('is-open'); document.body.style.overflow = ''; }));

  const initReveal = (scope) => {
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { threshold: .12 });
      $$('[data-reveal]', scope).forEach(el => io.observe(el));
    } else $$('[data-reveal]', scope).forEach(el => el.classList.add('is-in'));
  };
  initReveal(document);

  const initGalleries = (scope) => $$('[data-gallery]', scope).forEach(g => {
    const main = $('[data-gallery-main]', g);
    $$('[data-thumb]', g).forEach(t => t.addEventListener('click', () => {
      if (!main) return;
      main.removeAttribute('srcset'); main.src = t.dataset.src;
      $$('[data-thumb]', g).forEach(x => x.setAttribute('aria-current', 'false'));
      t.setAttribute('aria-current', 'true');
    }));
  });
  initGalleries(document);

  const initForms = (scope) => $$('[data-product-form]', scope).forEach(form => {
    if (form.dataset.bound) return; form.dataset.bound = '1';
    const box = form.closest('[data-buybox]') || form;
    const idInput = $('input[name="id"]', form);
    const planInput = $('[data-plan-input]', form);
    const btnLabel = $('[data-atc-label]', form);
    const update = (r) => {
      idInput.value = r.value;
      if (planInput) { const pl = r.dataset.plan || ''; planInput.value = pl; planInput.disabled = !pl; }
      const p = +r.dataset.price, c = +r.dataset.compare || 0;
      $$('[data-price-now]', box).forEach(el => el.textContent = money(p));
      $$('[data-price-was]', box).forEach(el => el.textContent = c > p ? money(c) : '');
      $$('[data-price-save]', box).forEach(el => { el.hidden = !(c > p); el.textContent = c > p ? 'Save ' + money(c - p) : ''; });
      if (btnLabel) {
        const lbl = btnLabel.dataset.label || 'Add to cart';
        const sp = btnLabel.dataset.showPrice !== 'false';
        btnLabel.textContent = r.dataset.available === 'false' ? 'Sold out' : lbl + (sp ? ' — ' + money(p) : '');
      }
      $$('[data-sticky-price]').forEach(el => el.textContent = money(p));
    };
    $$('input[data-variant]', form).forEach(r => r.addEventListener('change', () => update(r)));
    const q = $('[data-qty]', form);
    $$('[data-qty-btn]', form).forEach(b => b.addEventListener('click', () => {
      if (q) q.value = Math.max(1, (+q.value || 1) + (+b.dataset.qtyBtn));
    }));
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = $('[type=submit]', form); btn.disabled = true;
      const item = { id: +idInput.value, quantity: q ? (+q.value || 1) : 1 };
      if (planInput && !planInput.disabled && planInput.value) item.selling_plan = +planInput.value;
      try {
        await addItems([item]);
        await openDrawer();
      } catch (err) { HTMLFormElement.prototype.submit.call(form); }
      btn.disabled = false;
    });
  });
  initForms(document);

  document.addEventListener('click', async (e) => {
    const tab = e.target.closest('[data-tab]');
    if (tab) {
      const wrap = tab.closest('[data-tabs]');
      $$('[data-tab]', wrap).forEach(t => t.setAttribute('aria-selected', t === tab ? 'true' : 'false'));
      $$('[data-panel]', wrap).forEach(p => { p.hidden = p.dataset.panel !== tab.dataset.tab; });
      return;
    }
    const b = e.target.closest('[data-quick-add]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    try { await addItems([{ id: +b.dataset.quickAdd, quantity: 1 }]); await openDrawer(); } catch (err) { console.error(err); }
    b.disabled = false;
  });

  const initSticky = () => {
    const stickyBar = $('[data-sticky-atc]');
    const anchor = $('[data-sticky-anchor]');
    if (stickyBar && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => stickyBar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0)).observe(anchor);
    }
  };
  initSticky();

  document.addEventListener('shopify:section:load', (e) => { initReveal(e.target); initGalleries(e.target); initForms(e.target); initSticky(); $$('[data-reveal]', e.target).forEach(el => el.classList.add('is-in')); });

  const drawer = $('#CartDrawer'), overlay = $('#CartOverlay');
  async function openDrawer() { await renderCart(); drawer.classList.add('is-open'); overlay.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); }
  function closeDrawer() { drawer.classList.remove('is-open'); overlay.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); }
  $$('[data-cart-open]').forEach(a => a.addEventListener('click', (e) => { e.preventDefault(); openDrawer(); }));
  $$('[data-cart-close]').forEach(a => a.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeDrawer(); if (mnav) mnav.classList.remove('is-open'); document.body.style.overflow = ''; } });

  async function addItems(items) {
    const r = await fetch((root.routes && root.routes.cart_add || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
    if (!r.ok) throw new Error('add failed');
    return r.json();
  }
  async function changeLine(key, quantity) {
    await fetch((root.routes && root.routes.cart_change || '/cart/change') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
    renderCart();
  }
  const esc = (s) => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  async function renderCart() {
    const cart = await (await fetch((root.routes && root.routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } })).json();
    $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.dataset.count = cart.item_count; });
    const th = root.freeShip || 5000;
    const left = Math.max(0, th - cart.total_price);
    const st = $('[data-ship-text]');
    if (st) st.innerHTML = left > 0 ? 'You’re <b>' + money(left) + '</b> away from free shipping' : '<b>You’ve unlocked free shipping 🎉</b>';
    const sf = $('[data-ship-fill]');
    if (sf) sf.style.width = Math.min(100, cart.total_price / th * 100) + '%';
    const list = $('[data-cart-items]');
    if (!cart.items.length) {
      list.innerHTML = '<div class="drawer__empty"><p class="h3">Your cart’s as bare as your head.</p><a class="btn btn--sun" href="' + (root.heroUrl || '/collections/all') + '">Shop the Kit</a></div>';
    } else {
      list.innerHTML = cart.items.map(i => {
        const img = i.image ? i.image + (i.image.includes('?') ? '&' : '?') + 'width=160' : '';
        const plan = i.selling_plan_allocation && i.selling_plan_allocation.selling_plan ? '<div class="line__variant">' + esc(i.selling_plan_allocation.selling_plan.name) + '</div>' : '';
        return '<div class="line">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<span></span>') +
          '<div><div class="line__title">' + esc(i.product_title) + '</div>' + (i.variant_title && i.variant_title !== 'Default Title' ? '<div class="line__variant">' + esc(i.variant_title) + '</div>' : '') + plan +
          '<div class="line__qty"><button aria-label="Decrease" data-line="' + i.key + '" data-q="' + (i.quantity - 1) + '">−</button><span>' + i.quantity + '</span><button aria-label="Increase" data-line="' + i.key + '" data-q="' + (i.quantity + 1) + '">+</button></div></div>' +
          '<div class="line__price">' + money(i.final_line_price) + '</div></div>';
      }).join('');
      $$('[data-line]', list).forEach(b => b.addEventListener('click', () => changeLine(b.dataset.line, +b.dataset.q)));
    }
    const up = $('[data-upsell]');
    if (up) {
      const id = +up.dataset.variant;
      up.hidden = !cart.items.length || cart.items.some(i => i.variant_id === id);
    }
    const tot = $('[data-cart-total]');
    if (tot) tot.textContent = money(cart.total_price);
    const co = $('[data-checkout]');
    if (co) co.toggleAttribute('disabled', !cart.items.length);
  }
  root.openCart = openDrawer;
})();
